import useModalData from '../../../elements/Hooks/useModalData'
import { handleResponse } from '../../../modules/Utils'
import React from 'react'
import { get, pick } from 'lodash'
import { isEmpty } from 'lodash'
import Members from '../../../api/Members'
import Clients from '../../../api/Sales/Clients'
import Client from '../../../components/Sales/Client/Client'
import useFetchObject from '../../../elements/Hooks/useFetchObject'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useTitle from '../../../elements/Hooks/useTitle'

const api = new Clients()
const memberApi = new Members()

function ClientCont(props) {
  const key = props.match.params.key

  const { fetch: fetchMember, fetching: memberFetching, object: member } = useFetchObject(() =>
    memberApi.get(key).then(handleResponse),
  )

  const { object: client, fetch: fetchClient, fetching: fetchingClient } = useFetchObject(
    () => api.getMember(key),
    isEmpty(key),
  )

  const { list: repsList, fetching: repsListFetching, fetch: fetchRepsList } = useFetchList(
    () => memberApi.representatives.list(member._key).then(handleResponse),
    [member],
    isEmpty(member._key),
  )

  function fetch() {
    fetchClient()
    fetchMember()
    fetchRepsList()
  }

  const { visible, formRef, onShow: onEdit, onCancel, update, submitting } = useModalData(
    undefined,
    api.update,
    undefined,
    fetch,
    undefined,
    undefined,
    undefined,
    undefined,
    pick(client, ['_id', '_rev', '_key']),
  )

  useTitle(get(member, 'fn') || 'Client')

  return (
    <Client
      {...{
        fetch,
        fetchMember,
        memberFetching,
        member,
        client,
        fetchClient,
        fetchingClient,
        repsList,
        repsListFetching,
        fetchRepsList,
        visible,
        formRef,
        onEdit,
        onCancel,
        update,
        submitting,
      }}
    />
  )
}

ClientCont.propTypes = {}
ClientCont.defaultProps = {}

export default ClientCont
